var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8458",
    "data-name": "Group 8458",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.274,
    height: 22.285,
    viewBox: "0 0 19.274 22.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9628",
    "data-name": "Path 9628",
    d: "M15.747.794a4.926,4.926,0,1,0,3.485,1.442A4.936,4.936,0,0,0,15.747.794ZM9.89,1.865A7.5,7.5,0,0,0,2.981,9.335v6.03L1.465,18.551a.656.656,0,0,0,.592.937H6.671a3.831,3.831,0,0,0,7.647,0h4.615a.656.656,0,0,0,.592-.937l-1.515-3.187v-3.22a.655.655,0,1,0-1.311,0v3.368a.656.656,0,0,0,.064.281L17.9,18.178H3.1l1.133-2.383a.656.656,0,0,0,.064-.281V9.335A6.164,6.164,0,0,1,10,3.172a.655.655,0,1,0-.1-1.307Zm5.857.238A3.613,3.613,0,1,1,12.13,5.717,3.618,3.618,0,0,1,15.747,2.1ZM7.985,19.487H13a2.521,2.521,0,0,1-5.019,0Z",
    transform: "translate(-1.402 -0.794)",
    fill: "#253845"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications-icon.0f7599278fdad5b3cb46b926fa1fd334.svg";
export { ForwardRef as ReactComponent };